const ERROR_TYPES = {
  TRIGGER: '[error] trigger'
}

export default ERROR_TYPES
